<template>
  <div>
    <h1 class="mb-6">{{ $t('payments') }}</h1>
    <b-row v-if="hunterProfile">
      <b-col sm="6">
        <box class="p-4 mb-4 d-flex align-items-center">
          <svg-icon icon="earnings" class="text-info icon-2-5x mr-auto" />
          <div class="ml-2">
            <div class="text-right">
              <span class="h1 align-middle">{{
                hunterProfile.totalEarned
              }}</span>
            </div>
            <div class="text-right">
              <span class="text-lighten small">{{ $t('totalEarned') }}</span>
            </div>
          </div>
        </box>
      </b-col>
      <b-col sm="6">
        <box class="p-4 mb-4 d-flex align-items-center">
          <svg-icon icon="wallet" class="text-success icon-2-5x mr-auto" />
          <div class="ml-2">
            <div class="text-right">
              <button
                class="btn-sm btn-primary mr-3"
                title="Withdraw"
                v-b-modal.withdraw-modal
                data-cy="open-withdraw-modal"
              >
                {{ $t('withdraw') }}
              </button>
              <span class="h1 align-middle position-relative" style="top: 2px">
                {{ hunterProfile.balance }}
              </span>
            </div>
            <div class="text-right">
              <span class="text-lighten small">{{ $t('balance') }}</span>
            </div>
          </div>
        </box>
      </b-col>
    </b-row>

    <box
      class="w-100 p-0"
      v-if="hunterProfile && hunterProfile.withdrawalRequests"
    >
      <div class="table-responsive">
        <b-table
          show-empty
          :items="hunterProfile.withdrawalRequests"
          :fields="withdrawFields"
          class="mb-0"
          primary-key="a"
          data-cy="withdraw-requests"
        >
          <template slot="occurredAt" slot-scope="{ item }">
            <span class="text-light mr-2">{{
              $date.format(item.occurredAt, 'DD.MM.YYYY')
            }}</span>
            <sup class="text-light">{{
              $date.format(item.occurredAt, 'HH.mm')
            }}</sup>
          </template>
          <template slot="wallet" slot-scope="{ item }">
            <span class="text-light">{{ item.walletType }}:</span>
            {{ item.wallet }}
          </template>
          <template slot="status" slot-scope="{ item }">
            <b-badge
              :variant="statusClass(item.status)"
              class="text-uppercase"
              data-cy="request-status"
            >
              {{ $t(`statuses.${item.status}`) }}
            </b-badge>
          </template>
        </b-table>
      </div>
    </box>

    <withdraw-modal
      v-if="hunterProfile"
      :balance="hunterProfile.balance"
      @update-requests-list="loadHunterBalance"
    />
  </div>
</template>

<script>
import { statusClassesMixin } from '@/utils/mixins.js';
import WithdrawModal from './components/WithdrawModal.vue';

export default {
  mixins: [statusClassesMixin],

  components: {
    WithdrawModal
  },

  data() {
    return {
      hunterProfile: null,
      withdrawFields: [
        {
          label: this.$t('date'),
          key: 'occurredAt',
          thClass: 'text-nowrap pl-4 border-top-0',
          tdClass: 'pl-4'
          // formatter: val => {
          //   return this.$date.format(val, 'DD.MM.YYYY');
          // }
        },
        {
          label: this.$t('amount'),
          key: 'amount',
          thClass: 'text-nowrap pl-4 border-top-0',
          tdClass: 'pt-0 pb-0 pl-4 align-middle',
          sortable: false
        },
        {
          label: this.$tc('wallet', 1),
          key: 'wallet',
          thClass: 'text-nowrap border-top-0',
          tdClass: 'pt-0 pb-0 pl-4 align-middle',
          sortable: false
        },
        {
          label: this.$tc('comment', 1),
          key: 'comment',
          thClass: 'border-top-0 text-capitalize',
          tdClass: 'pt-0 pb-0 pl-4 align-middle cy-comment',
          sortable: false
        },
        {
          label: this.$tc('status', 1),
          key: 'status',
          thClass: 'text-nowrap border-top-0',
          tdClass: 'pt-0 pb-0 pl-4 align-middle',
          sortable: false
        },
        {
          label: this.$t('adminComment'),
          key: 'adminComment',
          thClass: 'text-nowrap border-top-0',
          tdClass: 'pt-0 pb-0 pl-4 align-middle',
          sortable: false
        }
      ]
    };
  },

  computed: {
    currentUserId() {
      return this.$store.getters.user.id;
    }
  },

  methods: {
    loadHunterBalance() {
      this.$api.bounty
        .get(`/v0/hunters/${this.currentUserId}/balance`)
        .then(res => {
          this.hunterProfile = res.data;
        })
        .catch(() => {
          this.$notify('alert', {
            text: this.$t('canNotGetUserBalance'),
            variant: 'danger',
            time: 5000
          });
        });
    }
  },

  created() {
    this.loadHunterBalance();
  }
};
</script>
